import InvalidMaskMessages from './InvalidMaskMessages';
import Messages from './Messages';

class LoginErrorMessages {
  private static readonly UPDATE_PASSWORD_DEFAULT_MESSAGES = [
    'NEW_PASSWORD_NOT_EQUAL',
    'ACTUAL_PASSWORD_NOT_EQUAL',
    'USER_NOT_FOUND',
    {
      name: 'INVALID_PASSWORD_MASK',
      factory: InvalidMaskMessages.getMessage,
    },
  ];

  private static readonly DEFAULT_ERROR_MESSAGES = {
    loginFail: 'Não foi possível realizar o login. Por favor, tente novamente mais tarde.',
    noLoginFound: 'Usuário/senha incorretos!',
    initSessionFailed: 'Não foi possível iniciar a sessão. Por favor, tente novamente mais tarde',
    updatePasswordFail: "Não foi possível alterar a senha. Por favor, tente novamente mais tarde",
    resetPasswordFail: 'Não foi possível redefinir a senha. Por favor, tente novamente mais tarde',
  };

  public static getChangePasswordMessage(
    error: string,
  ): string {
    const changePasswordMessage = this.getUpdatePasswordMessage(
      error,
      this.DEFAULT_ERROR_MESSAGES.updatePasswordFail,
    );

    return changePasswordMessage;
  }

  public static getResetPasswordMessage(
    error: string,
  ): string {
    const resetPasswordMessage = this.getUpdatePasswordMessage(
      error,
      this.DEFAULT_ERROR_MESSAGES.resetPasswordFail,
    );

    return resetPasswordMessage;
  }

  private static getUpdatePasswordMessage(
    error: string,
    defaultMessage: string,
  ): string {
    const updatePasswordMessage = this.UPDATE_PASSWORD_DEFAULT_MESSAGES.find((defaultMessage) => {
      const messageName = typeof defaultMessage === 'string' ?
        defaultMessage :
        defaultMessage.name;

      const messageExists = error.includes(messageName);

      return messageExists;
    });

    if (!updatePasswordMessage) {
      return defaultMessage;
    }

    const message = typeof updatePasswordMessage === 'string' ?
      Messages.getMessage(updatePasswordMessage) :
      updatePasswordMessage.factory(error);

    return message;
  }

  public static getInitSessionMessage(): string {
    return this.DEFAULT_ERROR_MESSAGES.initSessionFailed;
  }

  public static getConfirmationChangePasswordMessage(
    error: string,
  ): string {
    const indexCode = error.indexOf('{"CODE"');

    if (indexCode === -1) {
      return error;
    }

    const errorCode = error.substr(indexCode);
    const message = this.getChangePasswordMessage(errorCode);

    return message;
  }
}

export default LoginErrorMessages;
